import { connect } from "react-redux";
import PropTypes from "prop-types";
import React from "react";

import { closeDrawer, resetAppointmentSelections } from "@/redux/actions/calendar";
import { createClassNameString } from "@/utils/createClassNameString";
import { Image } from "@/component-library";

import CalendarAppointmentPicker from "../AppointmentPicker/CalendarAppointmentPicker";
import CalendarAppointmentView from "../AppointmentView/CalendarAppointmentView";

import "./styles.scss";

const CalendarDrawer = ({ calendar, calendarRect, className, direction, ...props }) => {
  const renderDrawerContent = () => {
    if (calendar.selectedEvents.length) {
      return calendar.selectedEvents.map((event) => (
        <CalendarAppointmentView
          calendarRect={calendarRect}
          event={event}
          key={event.callId || event.id}
        />
      ));
    }

    return <CalendarAppointmentPicker />;
  };

  const onCloseClick = () => {
    props.resetAppointmentSelections();
    props.closeDrawer();
  };

  return (
    <div
      className={createClassNameString([
        `apti-CalendarAppointmentPickerDrawer-Custom apti-CalendarAppointmentPickerDrawer-${direction}`,
        className,
      ])}
    >
      <div className="w-100 d-flex justify-content-end">
        <Image
          className="apti-CalendarAppointmentPickerDrawer--x-button pr-4 pt-2"
          onClick={onCloseClick}
          src="icons/icon-close-outline.svg"
        />
      </div>

      {renderDrawerContent()}
    </div>
  );
};

CalendarDrawer.propTypes = {
  calendarRect: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.string,
};

CalendarDrawer.defaultProps = {
  calendarRect: undefined,
  className: undefined,
  direction: "right",
};

const mapStateToProps = (state) => {
  return {
    calendar: state.calendar,
  };
};

const mapDispatchToProps = {
  closeDrawer,
  resetAppointmentSelections,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDrawer);
